exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.description[data-v-6d3e2752] {\n  background-color: inherit;\n  border: none;\n  font-family: inherit;\n  white-space: pre-wrap;\n}\n", ""]);

// exports
